import { SET_TRIP_SELECTION_STATUS } from '../../actions/common/exchange';

const exchange = (state = {}, action) => {
  switch (action.type) {
    case SET_TRIP_SELECTION_STATUS:
      return {
        ...state,
        tripSelectionStatus: action.payload,
      };
    default:
      return state;
  }
};

export default exchange;
